export class ButtonStyleDefaultsModel {
    fontSize: string;
    fontColor: string;
    bold: boolean;
    buttonColor: string;
    buttonBackgroundColor: string;
    buttonShape: number;

    constructor(
        fontSize: string,
        fontColor: string,
        bold: boolean,
        buttonColor: string,
        buttonBackgroundColor: string,
        buttonShape: number
    ) {
        this.fontSize = fontSize;
        this.fontColor = fontColor;
        this.bold = bold;
        this.buttonColor = buttonColor;
        this.buttonBackgroundColor = buttonBackgroundColor;
        this.buttonShape = buttonShape;
    }
}
